import { render } from "./ResetPassword.vue?vue&type=template&id=53b0f42a&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=53b0f42a&lang=stylus"
import "./ResetPassword.vue?vue&type=style&index=1&id=53b0f42a&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b0f42a"]])

export default __exports__